const entitcard = resolve => require(['@/pages/card/entitcard/index.vue'], resolve);
const cardslider = resolve => require(['@/pages/card/cardslider/index.vue'], resolve);
const cardsorderinfo = resolve => require(['@/pages/card/cardsorder/cardsorderinfo/index.vue'], resolve);
const cardsorder = resolve => require(['@/pages/card/cardsorder/index.vue'], resolve);
const cardstag = resolve => require(['@/pages/card/cardstag/index.vue'], resolve);
const cardsmanage = resolve => require(['@/pages/card/cardsmanage/index.vue'], resolve);
const cardcheckinfo = resolve => require(['@/pages/card/publishcard/cardcheckInfo/index.vue'], resolve);
const activecard = resolve => require(['@/pages/card/activecard/index.vue'], resolve);
const anotherBactch = resolve => require(['@/pages/card/publishcard/anotherbactch/index.vue'], resolve);
const bactchcard = resolve => require(['@/pages/card/publishcard/bactchcard/index.vue'], resolve);
const publishcard = resolve => require(['@/pages/card/publishcard/index.vue'], resolve);

export default [
  /********************美礼卡管理*****************/
  //美礼卡发行
  {
    path: "/publishcard",
    name: "美礼卡发行",
    component: publishcard
  },
  /*美礼卡发行下路由开始*/
  {
    path: "/publishcard/bactchcard",
    name: "发行礼卡",
    component: bactchcard
  },
  {
    path: "/publishcard/cardcheckinfo",
    name: "美礼卡发行批次详情",
    component: cardcheckinfo
  }, {
    path: "/publishcard/anotherBactch",
    name: "未上架的编辑",
    component: anotherBactch
  },
  /*美礼卡发行下路由结束*/
  //美礼卡审核
  {
    path: "/activecard",
    name: "美礼卡审核",
    component: activecard
  },
  /*美礼卡审核下路由开始*/
  {
    path: "/activecard/cardcheckinfo",
    name: "美礼卡审批批次详情",
    component: cardcheckinfo
  },
  /*美礼卡审核下路由结束*/
  //美礼卡管理
  {
    path: "/cardsmanage",
    name: "美礼卡管理",
    component: cardsmanage
  },
  //美礼卡标签
  {
    path: "/cardstag",
    name: "美礼卡标签",
    component: cardstag
  },
  //美礼卡订单管理
  {
    path: "/cardsorder",
    name: "美礼卡订单管理",
    component: cardsorder
  },
  /*美礼卡订单管理下路由开始*/
  {
    path: "/cardsorder/cardsorderinfo",
    name: "美礼卡订单详情",
    component: cardsorderinfo
  },
  /*美礼卡订单管理下路由结束*/
  //美礼卡轮播图
  {
    path: "/cardslider",
    name: "美礼卡轮播图",
    component: cardslider
  },
  //美礼卡精选
  {
    path: "/entitcard",
    name: "美礼卡精选",
    component: entitcard
  }
]
